import React from "react";
import RestaurantContainer from "../components/Restaurant/RestaurantContainer";

type Props = {};

const Restaurant = (props: Props) => {
  return (
    <div className="page">
      <RestaurantContainer />
    </div>
  );
};

export default Restaurant;
